// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nd-1";
export var messageSideRight = "_nd-2";
export var orderLookupBubbleContainer = "_nd-0";
export var submitButton = "_nd-3";